// src/services/api.js
import axios from 'axios';

// Criar instância do axios com configurações personalizadas
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api', 
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para requisições
api.interceptors.request.use(
  config => {
    // Pegar token do localStorage
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;

      // Evita mandar X-Role-Context em chamadas de login/registro
      const isAuthPath = /\/auth\/(login|register|registro|refresh)/i.test(config.url || '');
      if (!isAuthPath) {
        const role = localStorage.getItem('roleContext') || 'auto';
        config.headers['X-Role-Context'] = role;
      }
    }
    return config;
  },
  error => {
    console.error('Erro na requisição:', error);
    return Promise.reject(error);
  }
);

// Interceptor para respostas
api.interceptors.response.use(
  response => response,
  error => {
    if (error.code === 'ECONNABORTED') {
      console.error('A requisição excedeu o tempo limite.', error);
    }

    // Token expirado ou inválido — limpar sessão e redirecionar para login
    if (error.response?.status === 401) {
      const isAuthRoute = /\/(login|registro|reset-senha|solicitar-reset|verificar-email|reenviar-verificacao)/.test(
        error.config?.url || ''
      );
      if (!isAuthRoute) {
        localStorage.removeItem('usuario');
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('roleContext');
        // Redirecionar apenas se não estivermos já na página de login
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }

    if (error.response) {
      console.error('Erro na resposta da API:', {
        status: error.response.status,
        data: error.response.data
      });
    } else if (error.request) {
      console.error('Nenhuma resposta recebida:', error.request);
    } else {
      console.error('Erro na configuração da requisição:', error.message);
    }

    return Promise.reject(error);
  }
);

export default api;
